export class Referral {
	constructor(
		public id 		:	number,
		public token 	:	string,
		public mssg 	:	string
	) {}
}
